export default "__VITE_ASSET__B0jK40Rr__"